import { ReactElement, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { analyzeProductsListView } from '@client/analytics/redux';
import { EVENT_SOURCE } from '@client/analytics/types/types';
import { ProductAccessoryCategoryType } from '@client/product/redux/productAccessories/types';
import { Accordion, Section } from 'b2b-components/theme/components/Accordion';
import { Badge } from 'b2b-components/theme/components/Badge';
import { AccessoryItem } from './AccessoryItem';
import { Props } from './';

export const ProductAccessories = ({ sku, accessories = [] }: Props): ReactElement => {
  const dispatch = useDispatch();
  const sectionId = 'ProductDetails/ProductAccessories-Section';

  useEffect(
    () => {
      dispatch(analyzeProductsListView({
        eventSource: EVENT_SOURCE.accessories,
        skus: [sku],
      }));
    },
    [sku],
  );

  return (
    <Accordion defaultOpenIndexArray={accessories.length > 0 ? [0] : []}>
      {accessories
        .reduce(
          (allAccessories: { accIndex: number, category: ProductAccessoryCategoryType }[], category, index) => {
            const previousCategory = allAccessories[index - 1];

            return [
              ...allAccessories,
              {
                accIndex: previousCategory
                  ? previousCategory.accIndex
                    ? previousCategory.accIndex + previousCategory.category.count
                    : previousCategory.category.count
                  : 0,
                category,
              },
            ];
          },
          [],
        )
        .map(({ accIndex, category }) => (
          <Section
            sectionId={sectionId}
            key={category.label}
            title={(<>{category.label}<Badge>{category.count}</Badge></>)}
          >
            {category.products.map((accessory, productIndex) => (
              <AccessoryItem
                accessory={accessory}
                productSku={sku}
                listPosition={accIndex + productIndex + 1}
                key={accessory.sku}
              />
            ))}
          </Section>
        ))}
    </Accordion>
  );
};
